import React, { useEffect, useState } from 'react'
import styles from "./photo.module.css"

const Photo = ({setImageurl, imageurl}) => {
    const [loading, setLoading] = useState(false)
    useEffect(() => {
// var myHeaders = new Headers();
// myHeaders.append("Authorization", "Client-ID 21d3856601ec17f");

// var requestOptions = {
// method: 'GET',
// headers: myHeaders,
// redirect: 'follow'
// };

// fetch("https://api.imgur.com/3/album/ryQCmre", requestOptions)
// .then(response => response.json())
// .then(result => console.log(result))
// .catch(error => console.log('error', error));
}, [])

const convertLocalImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        // reader.onload(() => {
        //     resolve(reader.result)
        // });
        reader.onload = (event) => {
        const base64Image = event.target.result;
        resolve(reader.result.split(",")[1])
        console.log("Base64 Image:", base64Image);
      };
        // reader.onerror((error) => {
        //     reject(error)
        // })
        reader.readAsDataURL(file);
    })
}
const uploadToImgBB = async (base64Image) => {
    setLoading(true)
  const API_KEY = "584c7858f617faebb4bc176d46477254";
  const response = await fetch(
    `https://api.imgbb.com/1/upload?key=${API_KEY}`,
    {
      method: "POST",
      body: new URLSearchParams({ image: base64Image }),
    }
  );
  const data = await response.json();
        setImageurl(data.data.url)
         setLoading(false)
  return data.data.url; // Public image URL
}
const handleChange = async (e) => {
    const base64String = await convertLocalImageToBase64(e.target.files[0])
    uploadToImgBB(base64String);
    // setLoading(true)
    // const formdata = new FormData()
    // formdata.append("image", e.target.files[0])
    // fetch("https://api.imgur.com/3/image/", {
    //     method: "POST",
    //     headers: {
    //         Authorization: "Client-ID 6db47bd7029562d"
    //     },
    //     body: formdata
    // }).then(data => data.json()).then(data => {
    //     document.getElementById("img").src = data.data.link;
    //     setImageurl(data.data.link)
    //     setLoading(false)
    // })
}

  return (
    <div className={styles.profile__box}>
     {
        loading===true && <img  src={"loading-gif.webp"} id="img" alt='here profile' className={styles.profile__pic}/>
     }   
     {loading===false && <> 
    <label htmlFor="file">
    <img  src={imageurl} id="img" alt='here profile' className={styles.profile__pic}/>
    </label>
    <input onChange={(e) => handleChange(e)} type="file" id="file" name='profile_pic' className={styles.profile__file} />
    </>
     }
    </div>
  )
}

export default Photo